<template>
  <el-dialog :visible.sync="dialogVisible" width="600px" :before-close="handleClose" class="add-buyer-dialog"
    :close-on-press-escape="false" :close-on-click-modal="false" ref="dialog" v-loading="loading" title="订单进度分享" :append-to-body="true">
    <div class="add-item" style="margin-bottom: 23px">
      <div class="label">当前分享对象</div>
      <div class="content" style="display:flex;flex-wrap: wrap;">
        <span v-for="(item, index) in list" :key="index" class="email-item">
          {{ item.customer }}
          <el-button type="text" @click="delBuyer(index)" class="del-email">删除</el-button>
        </span>
      </div>
    </div>
    <div class="add-item">
      <div class="label" style="line-height: 38px;">新增分享对象</div>
      <div class="content">
        <div class="add-email-input" v-show="isAddBuyer">
          <div style="display: flex">
            <el-input v-model="currentBuyer" @keyup.enter.native="saveBuyer" ref="buyerInput" maxlength="200" placeholder="请输入买家名称或用户账号"></el-input>
            <el-button type="primary" class="add-email" @click="saveBuyer" :loading="addBuyerLoading">保存</el-button>
            <el-button class="cancel-add" @click="isAddBuyer = false" :loading="addBuyerLoading" style="margin-left: 11px;">取消</el-button>
          </div>
          <div class="err-msg" v-if="showAddBuyerErr">{{ buyerErrMsg }}</div>
        </div>
        <el-button class="add-btn" @click="addBuyer" v-if="!isAddBuyer">+添加分享对象</el-button>
      </div>
    </div>
    <div class="buyer-tips">添加后，订单进度和报告将共享给对方</div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSubmit" :disabled="loading">确定</el-button>
      <el-button @click="handleClose" :loading="loading" style="margin-left: 29px;">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'TicAddBuyer',
  props: {
    value: {
      type: Boolean,
      default: true
    },
    currentList: {
      type: Array,
      default() {
        return []
      }
    },
    orderNo: {
      type: String,
      default: ''
    },
    apis: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      list: [],
      isAddBuyer: false,
      currentBuyer: '',
      buyerErrMsg: '',
      showAddBuyerErr: false,
      addBuyerLoading: false
    }
  },
  watch: {
    value: {
      handler(val) {
        this.dialogVisible = val
        if (val) {
          this.list = []
        }
      },
      immediate: true
    },
    currentList: {
      handler(val) {
        this.list = val ? JSON.parse(JSON.stringify(val)) : []
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
    delBuyer(index) {
      this.list.splice(index, 1)
    },
    saveBuyer() {
      return new Promise(resolve => {
        if (!this.currentBuyer) {
          this.showAddBuyerErr = true
          this.buyerErrMsg = '请输入'
          resolve(false)
          return
        }
        if (this.list.some(v => v.customer === this.currentBuyer)) {
          this.showAddBuyerErr = true
          this.buyerErrMsg = '您已添加此买家'
          resolve(false)
          return
        }
        this.addBuyerLoading = true
        this.apis.getCustomerIdList({
          customers: [this.currentBuyer]
        }).then(res => {
          this.addBuyerLoading = false
          this.list = this.list.concat(res.data.items)
          this.isAddBuyer = false
          this.showAddBuyerErr = false
          resolve(true)
        }).catch(e => {
          resolve(false)
          if (e && e.resultMsg) {
            this.$message.closeAll()
            this.showAddBuyerErr = true
            this.buyerErrMsg = e.resultMsg
          }
          this.addBuyerLoading = false
        })
      })
    },
    addBuyer() {
      this.currentBuyer = ''
      this.buyerErrMsg = ''
      this.isAddBuyer = true
      this.showAddBuyerErr = false
      this.$nextTick(() => {
        this.$refs.buyerInput.focus()
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.$emit('input', false)
    },
    async handleSubmit() {
      let flag = true
      if (this.isAddBuyer) flag = await this.saveBuyer()
      if (!flag) {
        return
      }
      // if (!this.list.length) {
      //   this.$message.error('请添加分享对象')
      //   return
      // }
      this.loading = true
      this.apis.saveCustomer({
        orderNo: this.orderNo,
        customerList: JSON.parse(JSON.stringify(this.list))
      }).then(res => {
        this.loading = false
        this.$message.success('保存成功')
        location.reload()
      }).catch(e => {
        this.loading = false
        console.log(e);
      })
    },
  }
}
</script>

<style lang="scss">
.add-buyer-dialog {
  .el-dialog {
    border-radius: 10px;
  }

  .el-dialog__header {
    padding: 0 0 0 30px;
    .el-dialog__title {
      color: rgb(51, 51, 51);
      font-size: 16px;
      font-weight: 700;
      line-height: 54px;
    }
  }

  .el-dialog__body {
    padding: 30px 34px 42px 34px;
    .add-item {
      display: flex;
      .label {
        color: rgb(51, 51, 51);
        font-size: 14px;
        line-height: 18px;
        flex-shrink: 0;
        width: 102px;
      }
    }
    .el-button {
      width: 60px;
    }
    .err-msg {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
    }
    .add-btn.el-button.el-button--default {
      width: 132px;
      height: 36px;
      border: 1px solid rgb(202, 67, 0);
      border-radius: 4px;
      background: rgba(255, 102, 0, 0.05);
      color: rgb(202, 67, 0);
      font-size: 14px;
      line-height: 34px;
      text-align: center;
    }
    .el-input {
      width: 210px;
      margin-right: 17px;
    }
    .buyer-tips {
      padding-left: 102px;
      color: rgb(255, 60, 60);
      font-size: 12px;
      line-height: 16px;
      margin-top: 8px;
    }
  }
  .el-button {
    width: 100px;
    height: 40px;
    text-align: center;
    line-height: 38px;
    padding: 0;
  }

  .el-button.el-button--text {
    border: none;
    height: 18px;
    line-height: 18px;
    color: #333333;
    &:hover {
      color: #CA4300;
    }
  }

  .el-button.el-button--default {
    border-color: #CCCBCB;
    color: #878787;
    background: #fff;
  }
  .el-dialog__footer {
    text-align: center;
    padding-bottom: 45px;


  }
}</style>
